import React, { useContext } from 'react';
import AppointmentHelper from '../../../../helpers/appointment-helper';
import { RenderPresentedDates, RenderNoVisit, RenderBottomImage, RenderMainFilters } from '../common/common';
import { CommonContext } from '../../../../App';
import WidgetSizeHelper from '../../../../helpers/widget-size-helper';
import SubResult from '../../../../models/subresult';
import Appointment from '../../../../models/appointment';
import DateHelper from '../../../../helpers/date-helper';
import ScrollbarHelper from '../../../../helpers/scrollbar-helper';
import avatarFemale from '../../../../images/avatar_female.svg';
import avatarMale from '../../../../images/avatar_male.svg';
import noVisitsSrc from '../../../../images/no-visits-logo.png';
import config from '../../widget-config';
import mediClubLogo from '../../../../images/mediclub-logo.png';
import scrollDown from '../../../../images/scroll-down.svg';
import { createImportSpecifier } from 'typescript';
import MegawidgetCommonFacade from '../../../../facades/megawidget-specialty/megawidget-common.facade';
import ActionType from '../../../../models/enums/action-type';
import moment from 'moment';

export const MegawidgetMComponent: React.FC = () => {
  const { state, dispatch } = useContext(CommonContext);
  const url = window.location.href;
  const vendorCode = url.slice(url.indexOf('vendor:') + 'vendor:'.length, url.indexOf('doctorCode:') - 1);
  let doctorCode = '';
  let color = '';
  if (url.indexOf('color') > 0) {
     doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length, url.indexOf('color:') - 1);
     color = url.slice(url.indexOf('color:') + 'color:'.length);
  } else {
    doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length);  
  }
  if (false) {
    return <div className="m-container isLoading"></div>
  }
  else {
    return (
      <div className="m-container">
        <div className="m-header">
          <div style={{fontSize: "14px", color: "white", width: "100%"}}>Wybierz termin i kup wizytę</div>
        </div>
        {/* <div className="m-topbar" style={{ width: "30px", backgroundColor: "blue" }}> */}
          {/* <div className="m-topLogo"></div>
          <div className={state.bookVisit ? "m-topElement active" : "m-topElement"} onClick={() => dispatch({ type: "SET_BOOK_VISIT", payload: { bookVisit: true } })}>Umów wizytę</div>
          <div className={state.bookVisit ? "m-topElement" : "m-topElement active"} onClick={() => dispatch({ type: "SET_BOOK_VISIT", payload: { bookVisit: false } })}>Umów badanie</div> */}
        {/* </div> */}
        <div className="m-switchBar">
          {state.isTelemedicineAvailable && <div className={state.serviceInOffice ? "" : "bolded"}>Teleporada</div>}
          {state.isTelemedicineAvailable && <label className="switch">
            <input type="checkbox" defaultChecked={false} onChange={(x) => {
              var isTelemedicine = !x.target.checked;
              var groupsToDisplay: any = state.aggregatedData.filter((x) => (x as {telemedicine: boolean}).telemedicine === isTelemedicine);
              var specialities = groupsToDisplay.map(x => {return { description: x.description, additionalDesc: x.additionalDesc}});
              if (groupsToDisplay.length === 0) {
                
              } else {
              dispatch({
                type: ActionType.setAggregatedDataToDisplay,
                payload: { aggregatedData: groupsToDisplay},
              })
              dispatch({
                type: ActionType.setSpecialities,
                payload: { specialities: specialities},
              });
              dispatch({
                type: ActionType.setClinics,
                payload: { clinics: groupsToDisplay[0].clinics },
              });
              dispatch({
                type: ActionType.setAvailableDays,
                payload: { availableDays: groupsToDisplay[0].clinics[0].days },
              });
              dispatch({
                type: ActionType.setSelectedDate,
                payload: { selectedDate: new Date(groupsToDisplay[0].clinics[0].days[0].date) },
              });
              dispatch({
                type: ActionType.setClinicCode,
                payload: { selectedClinicCode: groupsToDisplay[0].clinics[0].code },
              });
        
              dispatch({
                type: ActionType.setClinicDescription,
                payload: { selectedClinicDescription: groupsToDisplay[0].clinics[0].description },
              });
        
              dispatch({
                type: ActionType.setRegionCode,
                payload: { selectedRegionCode: groupsToDisplay[0].clinics[0].regionCode },
              });
        
              dispatch({
                type: ActionType.setSpecialisationCode,
                payload: { selectedSpecialisationCode: groupsToDisplay[0].code },
              });
        
              dispatch({
                type: ActionType.setSpecialisationDescription,
                payload: { selectedSpecialisationDescription: groupsToDisplay[0].additionalDesc },
              });

            }
            }} />
            <span className="slider round"></span>
          </label>}
          <div className={state.serviceInOffice ? "bolded" : ""}>W gabinecie</div>
        </div>
        <div className="m-selectsDiv">
          {RenderMainFilters("m", 341, 341, 275, 50, 50, 15, state.selectedClinicDescription, state.selectedSpecialisationDescription)}
        </div>
        {/* {state.result.subResults.length > 0 ? */}
        {state.isLoading?
          <div className='loader'></div>
        :
          <>
            <div className="m-datesDiv">{RenderPresentedDates("m", WidgetSizeHelper.M.presentedDates)}</div>
            {/* <div className="m-selectsDiv">{RenderSubfilters(state.widgetSize, 204, 19, 732, 19, 468, 19)}</div> */}
            <div className="m-resultsDivParent">
              <div className="row m-resultsDiv">{RenderResultMSize()}</div>
            </div>
          </>
        }
        <hr style={{borderTop: "1px solid #bbb", width: "80%", marginTop: "26px"}}/>
        <div style={{ display: "flex", alignItems: "center", textAlign: "center"}}>
          { vendorCode.indexOf("OSOZ") == -1 ? vendorCode !== "Rehasport" ?<div className='m-footer'>lub zaloguj się do 
          {vendorCode === "Medicover" ? <a target="_blank" href={`https://mol.medicover.pl/Users/Account/AccessDenied?ReturnUrl=%2F`}> Medicover OnLine</a>
          : vendorCode === "CMD-Damian" || vendorCode === "CMD-MH"  ? <a target="_blank" href={`https://online24.damian.pl/?&utm_source=damian.pl&utm_medium=widget_doc&utm_campaign=w_no_slot`} style={{color: '#006639' }}> Damian Online</a>: <a target="_blank" href={``}> Blank Url</a>}
          </div> : <div className='m-footer'>Lub umów telefonicznie <a href="tel:+48616281181"> 616 281 181</a></div>           : <div></div>}
        </div>
        {/* {RenderBottomImage("m")} */}
      </div>
    )
  }
}

const RenderResultMSize = (): React.ReactElement => {
  const { state, dispatch } = useContext(CommonContext);
  const commonFacade = new MegawidgetCommonFacade(state, dispatch);
  const url = window.location.href;
  const vendorCode = url.slice(url.indexOf('vendor:') + 'vendor:'.length, url.indexOf('doctorCode:') - 1);
  let doctorCode = '';
  let color = '';
  if (url.indexOf('color') > 0) {
     doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length, url.indexOf('color:') - 1);
     color = url.slice(url.indexOf('color:') + 'color:'.length);
  } else {
    doctorCode = url.slice(url.indexOf('doctorCode:') + 'doctorCode:'.length);  
  }
  const vendorCodeToBackend = vendorCode === "CMD-MH" || vendorCode === "CMD-Damian" ? 'CMD' : vendorCode;
  const today = new Date();
  const dateTo = new Date();
  dateTo.setDate(today.getDate() + 30);
  const dateToOSOZ = new Date();
  dateToOSOZ.setDate(today.getDate() + 14);

  const RedirectToLoadedLink = (day: any, hour: string) => {
    const appointmentDate: Date = new Date(day.date);
    const splitedHour = hour.split(":");
    appointmentDate.setHours(Number(splitedHour[0].charAt(0) === '0' ? splitedHour[0].substring(1) : splitedHour[0]));
    appointmentDate.setMinutes(Number(splitedHour[1].charAt(0) === '0' ? splitedHour[1].substring(1) : splitedHour[1]));
    commonFacade.getRedirectionLink(state.selectedClinicCode, state.selectedSpecialisationCode, state.selectedRegionCode, doctorCode, vendorCodeToBackend, appointmentDate).then(urlObject => {
      var link = document.getElementById('link');
      link.setAttribute('href', urlObject.redirectionUrl);
      link.setAttribute('target', '_blank');
      console.log(urlObject);
      console.log(link);
      setTimeout(() => link.click(), 1000)
    });
  }

  const GetRedirectLink = (day: any, hour: string) => {
    const appointmentDate: Date = new Date(day.date);
    const splitedHour = hour.split(":");
    appointmentDate.setHours(Number(splitedHour[0].charAt(0) === '0' ? splitedHour[0].substring(1) : splitedHour[0]));
    appointmentDate.setMinutes(Number(splitedHour[1].charAt(0) === '0' ? splitedHour[1].substring(1) : splitedHour[1]));
    const clinicIndex = state.clinics.findIndex(x => x.code === state.selectedClinicCode) 
    const clinic = state.clinics[clinicIndex == -1 ? 0 : clinicIndex ];
    const date = moment(appointmentDate);
    return clinic.redirectionUrl.replace("DatePlaceHolder", date.format("yyyy-MM-DDTHH:mm:ss"));
  }
  
  const RedirectToLink = () => {
    window.open('https://www.medistore.com.pl/?utm_source=Medicover.pl&utm_medium=Pokaz-wizyty&utm_campaign=MD-static&utm_term=widget-brak-wizyt', '_blank', 'noopener,noreferrer');
  }
  return (
    <>
      {
        !state.slotsNotAvailable && state.availableDays.map((x) => {
          if (new Date((x as {date: string; hours: []}).date).getTime() === new Date((state.availableDays[state.currentPresentedDateIndex] as {date: Date; hours: []}).date).getTime()) {
            if ((x as {date: Date; hours: []}).hours.length > 0) {
              return ((x as {date: Date; hours: []}).hours.map((y, index: number) => {

                return (
                  <div className="m-singleResult" key={index}>
                    <div className="m-singleResultLeft">
                      <a target="_blank" href={GetRedirectLink(x, y)} className="m-singleResultHour">{y}</a>
                    </div>
                    {/* <div className="col-2 m-singleResultMiddle">
                      <img alt="photo" src={index % 2 === 0 ? avatarFemale : avatarMale} className="m-avatarImg" />
                    </div> */}
                    {/* <div className="col-8 m-singleResultRight">
                      <div className="row">
                        <div className="col-9">
                          <div className="m-singleResultDoctorType">{app.doctor.description ? app.doctor.description : "Brak danych"}</div>
                          <div style={{ fontSize: "14px" }}>{app.specialty.description ? app.specialty.description : "Brak danych"}</div>
                          <div style={{ fontSize: "14px" }}>{app.clinic.description ? `${app.clinic.description}, ${app.clinic.street}` : "Brak danych"}</div>
                        </div>
                        <div className="col-3" style={{ padding: "0" }}>
                          <div style={{ display: "grid", gridTemplateColumns: "auto auto" }}>
                            <div></div>
                            <div className="m-singleResultServicePrice">{app.price}.00 zł.</div>
                            <div><img src={mediClubLogo} style={{ width: "50px", marginBottom: "3px" }} /></div>
                            <div className="m-singleResultMedistoreClubPrice">100.00 zł.</div>
                          </div> }
                          <a target="_blank" href={`${config.CART_URL}?visit=true&doctor_code=${app.doctor.code}&re_location=${app.region.code}&location_id=${app.locationId}&product_id=${app.productId}&date=${app.dateTime}`} className="m-singleResultBuyServiceButton">Kup wizytę</a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                )
              }));
            }
            else {
              return (
                <div className="m-noVisitsContainer" style={{ height: "98%", margin: "0" }}>
                  <img src={noVisitsSrc} />
                  <span className="m-noVisitsText">Brak dostępnych wizyt</span>
                </div>
              )
            }
          }
        })
      }
      {
        state.slotsNotAvailable && (vendorCode === "Medicover") && <div className='m-slotsNotFound'>
          W terminie {today.toLocaleDateString()} - {dateTo.toLocaleDateString()} nie znaleziono wolnych wizyt.
          Sprawdź innych lekarzy.
          <button onClick={() => RedirectToLink() } className='m-slotNotFound-button'>Sprawdź</button>
        </div>  
      }
      {
        state.slotsNotAvailable && vendorCode === "CMD-Damian" && <div className='m-slotsNotFound'>
          W terminie {today.toLocaleDateString()} - {dateTo.toLocaleDateString()} nie znaleziono wolnych wizyt.
          <div>Zadzwoń <a href="tel:225662222">22 566 22 22</a> i umów się na późniejszy termin.</div>
        </div>
      }
      {
        state.slotsNotAvailable && vendorCode === "CMD-MH" && <div className='m-slotsNotFound'>
          W terminie {today.toLocaleDateString()} - {dateTo.toLocaleDateString()} nie znaleziono wolnych wizyt.
          <div>Zadzwoń <a href="tel:225662224">22 566 22 24</a> i umów się na późniejszy termin.</div>
        </div>
      }
      {
        state.slotsNotAvailable && vendorCode === "Rehasport" && <div className='m-slotsNotFound'>
          W terminie {today.toLocaleDateString()} - {dateTo.toLocaleDateString()} nie znaleziono wolnych wizyt.
          <div>Zadzwoń <a href="tel:616281181">616 281 181</a> i umów się na późniejszy termin.</div>
        </div>
      }
      {
        state.slotsNotAvailable && vendorCode.indexOf("OSOZ") > -1 && <div className='m-slotsNotFound'>
          W terminie {today.toLocaleDateString()} - {dateToOSOZ.toLocaleDateString()} nie znaleziono wolnych wizyt.
        </div>
      }
      {/* {
        state.result.subResults.find((sub: SubResult) => sub.appointmentsCounter >= state.maxAppointmentsToShow && sub.appointmentsDate.getTime() === state.selectedDate.getTime()) &&
        <a className="m-showAllResultsButton" target="_blank" href={`https://www.medicover.pl/lekarze/${state.selectedSpecialisationDescription}/${state.selectedRegionDescription},sl,s`}>Zobacz wszystkie</a>
      } */}
    </>
  )
}